import React, { useEffect } from 'react';
// import {  Route, Switch, BrowserRouter as Router, Redirect } from 'react-router-dom';
import {  Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import './scss/style.scss';
import iniciarConfiguracionAPI from './amplifyConfig';
import useAmplifyAuth from './customHooks/useAmplify'
import UserContext from  './context'

const load= (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/home/home'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));


const App = ()=> {
  useEffect(() => {
    iniciarConfiguracionAPI()
  }, [])
 
  const {
    state: { user,isLoading },
    roles,
    hasDigitalRole,
    handleSignout,
  } = useAmplifyAuth()
  
    return (
      !user?(<React.Suspense fallback={load}><Login isLoading={isLoading}/></React.Suspense>):
      (
      <UserContext.Provider value={{ handleSignout, load, user, roles, hasDigitalRole}}>
        <Router>
          <React.Suspense fallback={load}>
            <Switch>
            <Route path="/"  render={()=> <TheLayout/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            </Switch>
          </React.Suspense>
        </Router> 
      </UserContext.Provider>
        )
    );
}

export default App;
